import ButtonToggle from '../modules/button-toggle';
import { getCookie, setCookie } from '../utils/handle-cookies';

export default function CookieBanner() {
  /// Get Target CookieBanner
  const cookieBanner = document.getElementById("cookie-banner");

  /// If the cookie banner is present init
  if(cookieBanner != undefined) {

    /// Set Cookie Banners Cookies and Toggle
    const dismissCookieTarget = document.querySelector('.btn--dismiss-cookie');
    const dismissCookieToggle = new ButtonToggle();
    dismissCookieToggle.add('.btn--dismiss-cookie').run();

    /// Set a accpeted cookie
    dismissCookieTarget.addEventListener('click', () => {
      setCookie('CookiesAcknowledged', true, '365', '/')
      focusable(cookieBanner, false);
    })

    /// Check cookies to see if they've been accepted
    if(getCookie('CookiesAcknowledged') === 'true') {
      dismissCookieTarget.toggleButton(true);
      focusable(cookieBanner, false);
    }
  }
}

function focusable(thisElement, setFocus) {

  // set this element to be shown/hidden from the screen reader
  if(setFocus == true) {
    thisElement.removeAttribute('tabindex');
    thisElement.removeAttribute('aria-hidden');
  } else {
    thisElement.setAttribute('tabindex', '-1');
    thisElement.setAttribute('aria-hidden', 'true');
  }

  // get all the tabbable elements and show/hide them from the screen reader
  const tabbableElements = [
    'a[href]',
    'link[href]',
    'button',
    'input:not([type="hidden"])',
    'select',
    'textarea',
    '[draggable]',
    'audio[controls]',
    'video[controls]',
    '[tabindex]:not([tabindex="-1"])',
  ];
  thisElement.querySelectorAll(tabbableElements).forEach(element => {
    if(setFocus == true) {
      element.removeAttribute('tabindex');
      element.removeAttribute('aria-hidden');
      element.removeAttribute('disabled');
    } else {
      element.setAttribute('tabindex', '-1');
      element.setAttribute('aria-hidden', 'true');
    }
  })
}